import React from "react";
import { StyledContentBlock, Heading } from "./ContentBlock.styles";

const ContentBlock = ({ heading, children, ...rest }) => {
  return (
    <StyledContentBlock {...rest}>
      <Heading>{heading}</Heading>
      <div dangerouslySetInnerHTML={{ __html: children }} />
    </StyledContentBlock>
  );
};

export default ContentBlock;
